export const CHANGE_PARAMS = 'CHANGE_PARAMS';

export const changeParams = (field, value) => {
    return {
        type: CHANGE_PARAMS,
        field,
        value
    };
};
